<template>
    <button
        v-if="!checkbox && !as"
        type="button"
        class="ui-selectable-card"
        :class="cardClasses"
        :disabled="disabled || undefined"
        @click="!disabled && emit('click', $event)"
    >
        <div v-if="$slots.aside" class="ui-selectable-card__grid">
            <div class="ui-selectable-card__main"><slot /></div>
            <div class="ui-selectable-card__aside"><slot name="aside" /></div>
        </div>
        <slot v-else />
    </button>

    <component
        :is="checkbox ? 'div' : as"
        v-else
        class="ui-selectable-card"
        :class="cardClasses"
        :disabled="disabled || undefined"
        @click="!disabled && emit('click', $event)"
    >
        <!-- Checkbox variant -->
        <template v-if="checkbox">
            <div class="ui-selectable-card__inner">
                <input
                    type="checkbox"
                    :checked="selected"
                    :disabled="disabled"
                    class="ui-selectable-card__checkbox"
                    @click.stop
                    @change="!disabled && emit('click', $event)"
                />
                <div v-if="$slots.aside" class="ui-selectable-card__grid">
                    <div class="ui-selectable-card__main"><slot /></div>
                    <div class="ui-selectable-card__aside"><slot name="aside" /></div>
                </div>
                <div v-else class="flex-1 min-w-0"><slot /></div>
            </div>
        </template>

        <!-- Custom tag with aside -->
        <div v-else-if="$slots.aside" class="ui-selectable-card__grid">
            <div class="ui-selectable-card__main"><slot /></div>
            <div class="ui-selectable-card__aside"><slot name="aside" /></div>
        </div>

        <!-- Custom tag plain -->
        <slot v-else />
    </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    selected?: boolean;
    disabled?: boolean;
    checkbox?: boolean;
    compact?: boolean;
    as?: string;
}

const props = withDefaults(defineProps<Props>(), {
    selected: false,
    disabled: false,
    checkbox: false,
    compact: false,
    as: '',
});

const emit = defineEmits<{
    click: [event: Event];
}>();

const cardClasses = computed(() => ({
    'ui-selectable-card--selected': props.selected,
    'ui-selectable-card--disabled': props.disabled,
    'ui-selectable-card--compact': props.compact,
}));
</script>
